import { Controller } from "@hotwired/stimulus"

// Pop-up image lightbox for the app screenshots strip.
//
// Each thumbnail carries `data-lightbox-src-param` / `data-lightbox-caption-param`
// and a `click->lightbox#open` action. The overlay markup lives once in the
// partial as the `overlay`/`image`/`caption` targets.
export default class extends Controller {
	static targets = ["overlay", "image", "caption"]

	open(event) {
		const { src, caption } = event.params
		this.imageTarget.src = src
		this.imageTarget.alt = caption || ""
		if (this.hasCaptionTarget) this.captionTarget.textContent = caption || ""

		this.overlayTarget.classList.remove("hidden")
		this.overlayTarget.classList.add("flex")
		document.body.style.overflow = "hidden"
	}

	close() {
		this.overlayTarget.classList.add("hidden")
		this.overlayTarget.classList.remove("flex")
		document.body.style.overflow = ""
		this.imageTarget.removeAttribute("src")
	}

	// Only close when the click lands on the backdrop itself, not the image.
	closeBackground(event) {
		if (event.target === this.overlayTarget) this.close()
	}
}
